module.exports = __webpack_public_path__ + "static/media/bill-listing.0d6639fc.svg";